<template>
    <div>
        <CuentaAtras @tiempoTerminado="borrarSesion()"/>
        <PageTitle 
            :title="$t('home.parcelas')" 
            class="strech"
        />
        <div class="row">
            <b-col cols="12">
                <h2 class="h1 text-uppercase mt-5 text-center">{{ $t('nuevo_abono.terreno_title') }}</h2>
            </b-col>
        </div>
        <section class="padding-vertical-content">
            <b-container>
                <ContentOrLoading>
                    <Stepper
                        v-if="!loading"
                        ref="stepper"
                        :key="reloadComponents"
                        :steps="steps" 
                    >
                        <template #pasoZona="{ changeStep }">
                            <PasoUno :key="reloadComponents" @terminado="zona => { finalizarPasoUno(zona); changeStep(); }" />
                        </template>
                        <template #pasoParcelas="{ changeStep }">
                            <PasoDos ref="pasoDos" :key="reloadComponents" :zona="zona" @terminado="(datos) => { rellenarDatos(datos); changeStep(); }" @cambiarZona="() => { cambiarZona(); changeStep(true); }" />
                        </template>
                        <template #pasoDatos="{ changeStep }">
                            <PasoTres :key="reloadComponents" :datosParcelas="datosParcelas" :datosComprador="datos_comprador" @updateDatosComprador="datos => { datos_comprador = datos; }" @terminado="(jet_id, formulario) => { rellenarInfoTpv(jet_id, formulario); changeStep(); }" @cambiarAsiento="() => { borrarSesion(); changeStep(true); }" />
                        </template>
                        <template #pasoResumen="{ changeStep }">
                            <PasoCuatro :key="reloadComponents" :jet_id="jet_id" :formulario="formulario" :zona="zona" :datosParcelas="datosParcelas" @terminado="() => { changeStep(); }" @cambiarDatos="() => { changeStep(true); } " />
                        </template>
                        <template #pasoTarjeta="{ changeStep }">
                            <PasoCinco :key="reloadComponents" :jet_id="jet_id" @terminado="() => { changeStep(); }" />
                        </template>
                    </Stepper>
                </ContentOrLoading>
            </b-container>
        </section>
    </div>
</template>

<script>
    import PasoUno from '@/components/frontend/parcelas/PasoUno';
    import PasoDos from '@/components/frontend/parcelas/PasoDos';
    import PasoTres from '@/components/frontend/parcelas/PasoTres';
    import PasoCuatro from '@/components/frontend/parcelas/PasoCuatro';
    import PasoCinco from '@/components/frontend/parcelas/PasoCinco';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import Stepper from '@/components/frontend/events/compra/components/Stepper';
    import {useHead} from "@/composables/common/seo/useHead";

    export default {
        name: "Parcelas",
        data() {
            return {
                zona: null,
                jet_id: '',
                loading: false,
                formulario: '',
                datosParcelas: null,
                datos_comprador: {},
                reloadComponents: 1
            }
        },
        methods: {
            borrarSesion() {
                const params = {
                    cart_id: localStorage.getItem('cart_id')
                };

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.carrito.borrar'), params).then(res => {
                    this.zona = null;
                    localStorage.removeItem('session_id');
                    localStorage.removeItem('cart_id');
                    this.datosParcelas = null;
                    this.reloadComponents++;
                }).finally(() => {
                    this.loading = false;
                });
            },
            finalizarPasoUno(zona) {
                this.zona = zona;
            },
            cambiarZona() {
                this.zona = null;
            },
            rellenarDatos(datos) {
                this.datosParcelas = datos;
            },
            rellenarInfoTpv(jet_id, formulario) {
                this.jet_id = jet_id;
                this.formulario = formulario;
            }
        },
        computed: {
            steps() {
                const baseSteps = [
                    { label: this.$t('parcelas.selecciona_region'), slot: "pasoZona" },
                    { label: this.$t('parcelas.selecciona_parcelas'), slot: "pasoParcelas" },
                    { label: this.$t('parcelas.rellena_datos'), slot: "pasoDatos" },
                    { label: this.$t('parcelas.revisa_datos'), slot: "pasoResumen" }
                ];
                if (this.teatro.tipo_tpv === 2) {
                    baseSteps.push({ label: this.$t('parcelas.pago'), slot: "pasoTarjeta" });
                }
                return baseSteps;
            },
            teatro() {
                return this.$store.getters.getTeatro
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            listaAbonados() {
                return this.$store.getters.getListaAbonados;
            }
        },
        created() {
            useHead('Parcelas');
            if(!this.listaAbonados.activar_parcelas || this.footer.ocultar_parcelas || !this.footer.activar_parcelas) {
                this.$router.push({ name: "front.home" });
            }
        },
        components: {
            PasoUno, PasoDos, PasoTres, PasoCuatro, PasoCinco, PageTitle, CuentaAtras, Stepper
        }
    };
</script>